import axios from 'axios';
import { Helpers } from '../helpers/Helpers';
import { AddAntrepoVehicleInvoiceRequest } from '../models/request/invoice/AddAntrepoVehicleInvoiceRequest';
import { AddInvoiceRequest } from '../models/request/invoice/AddInvoiceRequest';
import { GetInvoiceListPagingAndFilterRequest } from '../models/request/invoice/GetInvoiceListPagingAndFilterRequest';
import { GetWillInvoicedListPagingAndFilterRequest } from '../models/request/invoice/GetWillInvoicedListPagingAndFilterRequest';
import { TopluFaturaSiparisi } from '../helpers/topluFatura';

export class InvoiceService {
    static async exportInvoiceList(inputObj: GetInvoiceListPagingAndFilterRequest) {
        try {
            console.log('SERVICE CALL - exportInvoiceList', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/Invoice/exportInvoiceList', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    /** Üst bar ikonu: Uyumsoft'ta hataya düşmüş kayıt sayısı (07.10.2026). */
    static async getEfaturaErrorCount(): Promise<{ isSuccess: boolean, message?: string, data: number }> {
        try {
            const resp = await axios.post(Helpers.getEndpoint() + '/Invoice/GetEfaturaErrorCount', {});

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async getInvoiceListPagingAndFilter(inputObj: GetInvoiceListPagingAndFilterRequest) {
        try {
            console.log('SERVICE CALL - GetInvoiceListPagingAndFilter', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/Invoice/GetInvoiceListPagingAndFilter', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async getWillInvoicedListPagingAndFilter(inputObj: GetWillInvoicedListPagingAndFilterRequest) {
        try {
            console.log('SERVICE CALL - GetWillInvoicedListPagingAndFilter', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/Invoice/GetWillInvoicedListPagingAndFilter', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async exportWillInvoicedList(inputObj: GetWillInvoicedListPagingAndFilterRequest) {
        try {
            console.log('SERVICE CALL - ExportWillInvoicedList', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/Invoice/ExportWillInvoicedList', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static getFormData(obj: any = {}, formData = new FormData(), key = '') {
        if (!([Array, File, Object].includes(obj.constructor))) {
            return formData;
        }

        // Handle File recursive
        if (obj instanceof File) {
            formData.append(key, obj);
            return formData;
        }

        for (const prop in obj) {
            // Validate value type
            if (obj[prop] && !([String, Number, Boolean, Array, Object, File].includes(obj[prop].constructor))) {
                continue;
            }

            // Set deep index of prop
            const deepKey = key ? key + `.${prop}` : prop;

            // Handle array
            if (Array.isArray(obj[prop])) {
                obj[prop].forEach((item: any, index: any) => {
                    this.getFormData(item, formData, `${deepKey}[${index}]`);
                })
                continue;
            }

            (typeof obj[prop] === 'object' && obj[prop] && obj[prop].constructor === Object)
                ? this.getFormData(obj[prop], formData, deepKey) // Handle object
                : formData.append(deepKey, [undefined, null].includes(obj[prop]) ? '' : obj[prop]) // Handle string, number, boolean
        }

        return formData;
    }

    static async addInvoice(inputObj: AddInvoiceRequest) {
        try {
            const formData = this.getFormData(inputObj);

            console.log('SERVICE CALL - AddInvoice', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/Invoice/AddInvoice', formData);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async addAntrepoVehicleInvoice(inputObj: AddAntrepoVehicleInvoiceRequest) {
        try {
            console.log('SERVICE CALL - addAntrepoVehicleInvoice', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/Invoice/addAntrepoVehicleInvoice', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async deleteInvoice(_ids: string[]) {
        try {
            var inputObj = {
                ids: _ids
            };

            console.log('SERVICE CALL - deleteInvoice', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/Invoice/deleteInvoice', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async getInvoiceById(_id: string) {
        try {
            var inputObj = {
                id: _id
            };

            console.log('SERVICE CALL - getInvoiceById', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/Invoice/getInvoiceById', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    /** Faturalanacaklar: secili Nakliye siparislerinden fatura olusturmadan once on kontrol. data: sorun listesi (bos = sorun yok). */
    static async checkInvoiceFromAmbars(_ambarIds: string[], _isSale: boolean, _currencyTypeId: string) {
        try {
            var inputObj = {
                ambarIds: _ambarIds,
                isSale: _isSale,
                currencyTypeId: _currencyTypeId
            };

            console.log('SERVICE CALL - checkInvoiceFromAmbars', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/Invoice/CheckInvoiceFromAmbars', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async groupInvoiceDetails(_invoiceId: string) {
        try {
            var inputObj = {
                invoiceId: _invoiceId
            };

            console.log('SERVICE CALL - groupInvoiceDetails', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/Invoice/groupInvoiceDetails', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    // Faturalanacaklar (19.10.2026): seçili siparişlerden tek istekte, tek işlemde fatura (hepsi ya da hiçbiri).
    static async addInvoiceFromOrders(_siparisler: TopluFaturaSiparisi[], _isSale: boolean, _currencyTypeId: string, _ignoreWithholding?: boolean) {
        try {
            var inputObj = {
                isSale: _isSale,
                currencyTypeId: _currencyTypeId,
                ignoreWithholding: _ignoreWithholding,
                siparisler: _siparisler
            };

            // Binlerce sipariş olabilir; günlüğe listenin yalnız sayısı yazılır.
            console.log('SERVICE CALL - addInvoiceFromOrders', JSON.stringify({ ...inputObj, siparisler: _siparisler.length }));

            const resp = await axios.post(Helpers.getEndpoint() + '/Invoice/addInvoiceFromOrders', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    // static async getInvoiceList() {
    //     try {
    //         var inputObj = {
    //         };

    //         console.log('SERVICE CALL - getInvoiceList', JSON.stringify(inputObj));

    //         const resp = await axios.post(Helpers.getEndpoint() + '/Invoice/getInvoiceList', inputObj);

    //         return Helpers.dataParser(resp);
    //     } catch (error) {
    //         throw Helpers.parseErrorMessage(error);
    //     }
    // }
}